import { lazy } from 'react';

export const EditApplicationsLazy = lazy(() => import('./EditApplications'));
